import { CustomDialog } from '../../components/CustomDialog';
import { useState } from 'react';
import {
  AutoCompleteController,
  InputController,
} from '../../components';
import { useAppDispatch } from '../../storeHook';
import { showAlert } from '../../services/alert';
import { useUpdateDeliveryScheduleMutation } from '../../services/deliverySchedules';
import * as yup from 'yup';
import { useFormWithSchema } from '../../utils/functions/yupFormTypescript';
import { TEditDeliveryScheduleProps } from '../../utils/types';
import { TRANSPORTER_TYPES } from './helpers/constants';

const formSchema = yup.object({
  partnerMobile: yup
    .string()
    .required('please enter mobile number'),
  transporterType: yup
    .string()
    .required('please select transporter type'),
  isDispatched: yup
    .string()
    .required('please select order status'),
  lrNumber: yup.string(),
  transporterName: yup.string(),
});
type TFormData = yup.InferType<typeof formSchema>;

export const EditDeliverySchedule: React.FC<
  TEditDeliveryScheduleProps
> = ({ fetchedData, setEditDiscountData }) => {
  const {
    formState: { errors },
    handleSubmit,
    register,
    control,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
    defaultValues: {
      partnerMobile: fetchedData.partnerMobile,
      transporterType: fetchedData.transporterType,
      lrNumber: fetchedData.lrNumber,
      transporterName: fetchedData.transporterName,
      isDispatched:
        fetchedData.deliveryScheduleStatus == 'Dispatched'
          ? 'Yes'
          : 'No',
    },
  });

  const dispatch = useAppDispatch();
  const [update] = useUpdateDeliveryScheduleMutation();
  const [open, setOpen] = useState(true);

  const onUpdateClick = (data: TFormData) => {
    update({
      id: fetchedData.id,
      sapOrderId: fetchedData.sapOrderId,
      retailerSalesOrderId:
        fetchedData.retailerSalesOrderId,
      ...data,
    })
      .unwrap()
      .then((res) => {
        setEditDiscountData(undefined);
        dispatch(
          showAlert({
            content: res.message,
            severity: res.success ? 'success' : 'error',
          })
        );
      })
      .catch((err) => {
        console.log('error', err);
        // this.utility.handleError(err);
      });
  };

  return (
    <>
      <CustomDialog
        dialogTitle={'Update Delivery Schedule'}
        open={open}
        setOpen={(value) => {
          setEditDiscountData(undefined);
          setOpen(value);
        }}
        onSubmit={handleSubmit((data) =>
          onUpdateClick(data)
        )}
        actionText={{ submit: 'Update', cancel: 'Cancel' }}
        maxWidth="lg">
        <form
          onSubmit={handleSubmit((data) =>
            onUpdateClick(data)
          )}
          className="grid grid-cols-2 gap-x-5 pb-20">
          <div className="col-span-full grid grid-cols-2">
            <InputController
              label="Delivery Partner Mobile Number"
              placeholder="Enter mobile Number"
              register={register('partnerMobile')}
              error={errors.partnerMobile?.message}
              required
              disabled={
                fetchedData.deliveryScheduleStatus ==
                'Delivered'
              }
            />
          </div>
          <div className="col-span-full font-bold mt-3">
            Dispatch Orders:
          </div>

          <div className="col-span-full my-2">
            to-do status radion input selection
          </div>
          <InputController
            label="LR Number"
            register={register('lrNumber')}
            error={errors.lrNumber?.message}
          />
          <InputController
            label="Vehicle Number"
            register={register('transporterName')}
            error={errors.transporterName?.message}
          />
          <AutoCompleteController
            label="Transporter Type"
            name="transporterType"
            control={control}
            options={TRANSPORTER_TYPES}
            error={errors.transporterType?.message}
            disabled={
              fetchedData.deliveryScheduleStatus ==
              'Delivered'
            }
            required
          />
        </form>
      </CustomDialog>
    </>
  );
};
